import { ACTION_TYPES } from 'lib/Constants';

const {
  LOAD_QRCODE_SUCCESS,
  LOAD_ORG_DETAIL,
  LOAD_CATEGORIES,
  LOAD_COMMUNITIES,
  ASSOCIATEDORG_SUCCESS,
  LOAD_BUILDING_QRCODE,
  LOAD_QR_BUILDING_DETAIL,
  ASSOCIATEDORG_BUILDING_SUCCESS,
  DOWN_ORG_QRCODE,
  VENDOR_FORMDATA,
  QR_CREATE
} = ACTION_TYPES;


export default {
  LOAD_QRCODE_SUCCESS: LOAD_QRCODE_SUCCESS,
  LOAD_ORG_DETAIL: LOAD_ORG_DETAIL,
  LOAD_CATEGORIES:LOAD_CATEGORIES,
  LOAD_COMMUNITIES:LOAD_COMMUNITIES,
  ASSOCIATEDORG_SUCCESS: ASSOCIATEDORG_SUCCESS,
  LOAD_BUILDING_QRCODE: LOAD_BUILDING_QRCODE,
  LOAD_QR_BUILDING_DETAIL:LOAD_QR_BUILDING_DETAIL,
  ASSOCIATEDORG_BUILDING_SUCCESS: ASSOCIATEDORG_BUILDING_SUCCESS,
  DOWN_ORG_QRCODE: DOWN_ORG_QRCODE,
  VENDOR_FORMDATA:VENDOR_FORMDATA,
  QR_CREATE:QR_CREATE
}
